module.exports = __webpack_public_path__ + "img/activity-feed-icon.accd08b7.svg";